export const createSubeventJsonLd = ({
	locationName,
	name,
	startDate,
	url,
}: {
	locationName: string;
	name: string;
	startDate: string;
	url: string;
}) => {
	let json = '';
	let error = '';
	try {
		json = JSON.stringify({
			'@context': 'https://schema.org',
			'@type': 'SportsEvent',
			name,
			url,
			startDate,
			location: {
				'@type': 'Place',
				name: locationName,
				address: {
					'@type': 'PostalAddress',
					name: '',
				},
			},
		});
	} catch (err) {
		error = `<!-- JSONLD object failed to serialize${
			err instanceof Error ? `: ${err.message}` : ''
		} -->`;
	}
	return json ? (
		<script
			dangerouslySetInnerHTML={{
				__html: json,
			}}
			type="application/ld+json"
		/>
	) : (
		<div dangerouslySetInnerHTML={{ __html: error }} />
	);
};
